import React, { useState, useEffect, useCallback } from "react";
import { socketConn } from "../../../helper/socket-io";

import { EquityCurveChart } from "../../common-components";
import Refresh from "../../../assets/images/refresh-2.png";
import Doller from "../../../assets/images/doller.png";

const LiveStats = ({ isOpen, setOpen }) => {
  const [socket, setSocket] = useState(null);
  const [data, setData] = useState(null);
  const [chartData, setChartData] = useState([])

  const connectSocket = useCallback(() => {
    if (!socketConn.connected) {
      console.log(31, "connect now");
      socketConn.connect();
    }

    socketConn.on("connect", () => {
      console.log("Connected to server");
    });

    socketConn.on("disconnect", () => {
      console.log("Disconnected from server");
    });

    setSocket(socketConn);

    return () => {
      // socketConn.disconnect();
    };
  }, []);

  useEffect(() => {
    const cleanup = connectSocket();
    return () => {
      cleanup();
      setSocket(null);
    };
  }, [connectSocket]);

  useEffect(() => {
    if (isOpen && socket) {
      socket.emit("liveStats", null, (response) => {});
      socket.emit("getChartData", null, (response) => {
        console.log(44, response)
        setChartData(response.data)
      });
      
    }
  }, [isOpen]);

  useEffect(() => {
    if (socket) {
      socket.on(
        "liveStats",
      
        (response) => {
          // console.log("liveStats", response)
          setData(response.data)
        }
      );
    }
  }, [socket]);

  if (!isOpen) return null;

  return (
    <div className=" flex items-center justify-center rounded ">
      <div className="bg-gray-800 w-[available] rounded-lg shadow-lg  ">
        <div className="w-full p-2 p-sm-3 justify-content-between d-flex bg-secondary-gray rounded">
          <p className="text-sm text-white font-semibold">Live Stats</p>
          <button
            className=" text-gray-500"
            onClick={() => setOpen((prev) => ({ ...prev, startup: !isOpen }))}
          >
            ✖
          </button>
        </div>

        <div>
          <div className="bg-primary-gray p-2 p-sm-3 relative overflow-x-auto shadow-md sm:rounded-lg">
            <div className=" rounded-lg border-1 border-gray-700 cursor-pointer w-[fit-content] p-1 bg-secondary-gray"
              onClick={() => {
                socket.emit("liveStats", null, (response) => {});
                socket.emit("getChartData", null, (response) => {
                  console.log(87, response)
                  setChartData(response.data)
                });
              }}
            >
              <img src={Refresh} className="coin-img m-1 " alt="refresh" />
            </div>

            <div className="bg-secondary-gray rounded p-1  my-2">
              <div className="d-flex">
                <div className="flex-1 bg-primary-gray p-1 p-sm-2 rounded m-1 m-sm-2 rounded-lg border-1 border-gray-700 text-gray-primary">
                  Profit <br />
                  <span className="f-green font-semibold d-flex justify-content-between">
                    {" "}
                    {data?.profit?.toFixed(2)} <img src={Doller} className="coin-img m-1" alt="icon" />
                  </span>
                </div>
                <div className="flex-1 bg-primary-gray p-1 p-sm-2 rounded m-1 m-sm-2 rounded-lg border-1 border-gray-700 text-gray-primary">
                  Wins <br />
                  <span className="f-green font-semibold d-flex justify-content-between">
                  {data?.wins?.toFixed(2)} <img src={Doller} className="coin-img m-1" alt="icon" />
                  </span>
                </div>
              </div>
              <div className="d-flex">
                <div className="flex-1 bg-primary-gray p-1 p-sm-2 rounded m-1 m-sm-2 rounded-lg border-1 border-gray-700 text-gray-primary">
                  Wagered <br />
                  <span className="text-white font-semibold"> {data?.wagered?.toFixed(2)} </span>
                </div>
                <div className="flex-1 bg-primary-gray p-1 p-sm-2 rounded m-1 m-sm-2 rounded-lg border-1 border-gray-700 text-gray-primary">
                  Losses <br />
                  <span className="f-red font-semibold ">{data?.losses?.toFixed(2)}</span>
                </div>
              </div>
            </div>
            <EquityCurveChart chartData={chartData}  />
          </div>
        </div>
      </div>
      
    </div>
  );
};

export default LiveStats;
